/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./EnterAdTipsDialog.vue?vue&type=template&id=889fa06e&scoped=true"
import script from "./EnterAdTipsDialog.vue?vue&type=script&lang=js"
export * from "./EnterAdTipsDialog.vue?vue&type=script&lang=js"
import style0 from "./EnterAdTipsDialog.vue?vue&type=style&index=0&id=889fa06e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889fa06e",
  null
  
)

export default component.exports